import styled from 'styled-components'

export const LoginPageContainer = styled.div<{
    backgroundImage?: string
}>`
    ${({ backgroundImage }) =>
        backgroundImage &&
        `
        background-image: url(${backgroundImage});
        background-size: cover;
        background-position: center;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    `}
`
